module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class=\'c-wkfhisto d-flex flex-column\'>\r\n  '+
((__t=( content))==null?'':__t)+
'\r\n</div>\r\n';
}
return __p;
};
